import { render, staticRenderFns } from "./DemandeInscriptionPsychologue.vue?vue&type=template&id=7f70c6a6"
import script from "./DemandeInscriptionPsychologue.vue?vue&type=script&lang=js"
export * from "./DemandeInscriptionPsychologue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports